import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../client/ClientStyle/client.css";
import dayjs from "dayjs";
import * as ClientStyle from "../../client/ClientStyle/clientStyle";
import Button from "@mui/material/Button";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import updateimg from "../../../assets/edit-512.webp";
import deleteimg from "../../../assets/supr.jpg";
import { makeStyles } from "@mui/material/styles";
  import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Autocomplete from "@mui/material/Autocomplete";
import ButtonGroup from "@mui/material/ButtonGroup";

import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TextField,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { AjoutFacture } from "./ajoutFacture";

export const SelectFacture = ({
  afficheAjoutFact,
  setFactures,
  ajoutReglement,
  modifierFct,
  suprFct,
}) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const searchTextFieldRef = useRef(null);
  useEffect(() => {
    if (searchTextFieldRef.current) {
      searchTextFieldRef.current.focus();
    }
  }, []);
  const [typeFacture, setTypefacture] = useState("");
  const [dateDebutS, setDateDebutS] = useState(dayjs(new Date()));
  const [dateFinS, setDateFinS] = useState(dayjs(new Date()));
  const [numFct, setNumFct] = useState("");
  // const listerPaiement = () => {
  //   axios
  //     .get(
  //       `${apiUrl}IHM/api/paiement.php?searchPaie=${searchP}&debut=${dateDebutS}&fin=${dateFinS}&modeP=${modePaiement}&locSearch=${idLoc}`
  //     )

  //     .then((response) => {
  //       console.log("paiements leka", response.data);
  //       setFactures(response.data);
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     });
  // };

  const listerFact = () => {
    axios
      .get(`${apiUrl}IHM/api/facture.php?searchClient=${searchClient}&debut=${dateDebutS}&fin=${dateFinS}&typeFct=${typeFacture}&numFact=${numFct}`)
      .then((response) => {
        setFactures(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };


  const [searchClient, setSearchClient] = useState("");
  useEffect(() => {
    listerFact(); 
  }, [
    afficheAjoutFact,
    modifierFct,
    suprFct,
    searchClient,
    numFct,
    dateDebutS,
    dateFinS,
    typeFacture,
  ]);

  useEffect(() => {
    setSearchClient("");
    setNumFct("");
    setTypefacture("");
    setDateDebutS("");
    setDateFinS("");
  }, [ajoutReglement]);
  function formatDate(date) {
    const selectedDate = new Date(date);
    const year = selectedDate.getFullYear();
    const month = (selectedDate.getMonth() + 1).toString().padStart(2, "0");
    const day = selectedDate.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const handleDebutChange = (date) => {
    const formattedDate = formatDate(date);
    setDateDebutS(formattedDate);
  };

  const handleFinChange = (date) => {
    const formattedDate = formatDate(date);
    setDateFinS(formattedDate);
  };
  const [erreur, setErreur] = useState(false);
  const handleTypefactChange= (e) => {
    setTypefacture(e.target.value);
  };

  const handleNumFctChange = (e) => {
    const inputValue = e.target.value;
    // Expression régulière pour vérifier le format spécifique avec possibilité de saisie progressive
    const formatRegex = /^\d{0,8}-?\d{0,6}$/;

    if (formatRegex.test(inputValue)) {
        setNumFct(inputValue);
        setErreur(false);
    } else {
        setErreur(true);
    }
};

  const renderFactList = () => {
    return (
      <div className=" ">
        <div className=" ">
          <div className=" ">
            <Box>  
              <div style={{ display: "flex", alignItems: "center" }}>
                <TextField
                  id="standard-search"
                  label="Client "
                  type="text"
                  variant="standard"
                  value={searchClient}
                   onChange={(e) => {
                  setSearchClient(e.target.value.trimStart());
                 }}
                  inputRef={searchTextFieldRef}
                  style={{ width: "60%", marginRight: "10px" }}
                />

                <TextField
                  id="standard-search"
                  label="N° facture"
                  variant="standard"
                  type="text"
                  value={numFct}
                  style={{ width: "33%" }}
                  onChange={handleNumFctChange}
                  error={erreur}
                  
                />

              </div>
              <br /> <br />
              <br />
              <DemoContainer components={["DatePicker"]}>
                <DemoItem label="Date d'envoie de la facture: ">
                  <DatePicker
                    format="DD-MM-YYYY"
                    label="Début (Date d'envoie)"
                    onChange={handleDebutChange}
                  />
                  <DatePicker
                    format="DD-MM-YYYY"
                    label="Fin (Date d'envoie)"
                    onChange={handleFinChange}
                  />
                </DemoItem>
              </DemoContainer>
              <br /> <br />
              <FormControl variant="standard" fullWidth>
                <InputLabel id="modePaie-label">Type de facture</InputLabel>

                <Select
                  labelId="modePaie-label"
                  id="typeFacture"
                  value={typeFacture}
                  onChange={handleTypefactChange}
                >        <MenuItem value=""> Tout </MenuItem>
                    <MenuItem value="FAP">FAP (Facture à Payé)</MenuItem>
                    <MenuItem value="FP">FP (Facture Payé)</MenuItem>
                    {/* <MenuItem value="EC">EC (Encours)</MenuItem> */}
             
                </Select>
              </FormControl>{" "}
              <br /> <br />
              <div> </div>
            </Box>  
          </div>
        </div>
      </div>
    );
  };

  //***********************************FIN TABLEAU TABLEAU TABLEAU******************************* */

  return <div>{renderFactList()}</div>;
};
